module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"OWNER":"Owner","CONSIGNER":"Consigner","PRESENTER":"Présentateur","VISIT":"Place visit","REGISTRATION":"Registration"}}')
  delete Component.options._Ctor
}
